import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
  model,
  ViewChild,
} from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import { Preset, UserCpuResult } from '../../../../shared/models/usage.models';
import { SegmentOption } from '../../../../shared/components/segmented-radio/segmented-radio.models';
import { SegmentedRadioComponent } from '../../../../shared/components/segmented-radio/segmented-radio.component';
import { ChartConfiguration, ChartType } from 'chart.js';
import moment from 'moment';
import { BytesToSizePipe } from '../../../../shared/pipes/bytes-to-size-pipe';

@Component({
  selector: 'app-cpu',
  imports: [BaseChartDirective, SegmentedRadioComponent],
  providers: [BytesToSizePipe],
  templateUrl: './cpu.component.html',
  styleUrl: './cpu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CpuComponent {
  private sizePipe = inject(BytesToSizePipe);

  usage = input.required<UserCpuResult>();

  selectedPeriod = model<Preset>('30d');

  periods: SegmentOption[] = [
    { label: 'Last 24 hours', value: '24h' },
    { label: 'Last 7 days', value: '7d' },
    { label: 'Last 30 Days', value: '30d' },
  ];

  lineChartData: ChartConfiguration['data'] = {
    datasets: [
      {
        data: [100, 200],
        label: 'Usage',
        backgroundColor: '#322b42',
        borderWidth: 4,
        borderColor: '#a78bfa',
        pointBackgroundColor: '#776a93',
        pointBorderColor: '#a78bfa',
        pointHoverBackgroundColor: '#d7cfe5',
        pointHoverBorderColor: '#a290c9',
        fill: 'origin',
        pointRadius: 0,
        pointHoverRadius: 0,
      },
    ],
    labels: ['1 Jan', '31 Jan'],
  };

  lineChartOptions: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: {
        tension: 0.5,
      },
    },
    scales: {
      // We use this empty structure as a placeholder for dynamic theming.
      y: {
        position: 'left',
      },
      y1: {
        position: 'right',
        grid: {
          display: false,
        },
        ticks: {
          display: false,
        },
      },
    },

    plugins: {
      legend: { display: false },
    },
  };

  public lineChartType: ChartType = 'line';

  @ViewChild(BaseChartDirective) chart?: BaseChartDirective;

  constructor() {
    effect(() => {
      this.lineChartData.datasets[0].data = this.usage().points.map((p) => p.value / 1024 / 1024);
      this.lineChartData.labels = this.usage().points.map((p) =>
        moment
          .unix(p.timestampUnixSeconds)
          .format(this.selectedPeriod() === '24h' ? 'HH:mm' : 'DD MMM'),
      );
      this.chart?.update();
    });
  }
}
